import { INSTALLED_TARIFF_OPTION } from '@oskecare/fe-utilities/lib/constants/dataSources';
import { cacheWithErrorCheck } from '../../helpers.js';
import InstalledTariffOption from './models/InstalledTariffOption.js';
import { TARIFF_OPTION_ID_PREPAID_STARTER_PACK_DETAIL } from './constants.js';

export default class TariffOption {
  /**
   * @param {string} apiUrl
   * @param {Map<string, Promise<*>>} cache
   * @param {function} request
   * @param {CustomerDataManager} customerDataManager
   */
  constructor({ apiUrl, cache, request, customerDataManager }) {
    this._productDomainApiUrl = apiUrl;
    this._cache = cache;
    this._request = request;
    this._customerDataManager = customerDataManager;
  }

  /**
   * @param {string} sn
   * @param {string} tariffOptionId
   * @param {boolean} isNonessential
   * @return {Promise<InstalledTariffOption>}
   * @private
   */
  async _tariffOptionRequest({ sn, tariffOptionId, isNonessential = false }) {
    const { subscriptionId } = (await this._customerDataManager.getCustomerData()).getSnDataBySn(
      sn,
    );

    return cacheWithErrorCheck(
      this._cache,
      `tariffOption.subscriptionId-${subscriptionId}.tariffOptionId-${tariffOptionId}`,
      () =>
        this._request({
          method: 'GET',
          route: `${this._productDomainApiUrl}/subscription/${subscriptionId}/installedTariffOption`,
          query: {
            detail: true,
            tariffOptionId,
          },
          dataSource: INSTALLED_TARIFF_OPTION,
          isNonessential,
        }).then(data => new InstalledTariffOption(data)),
    );
  }

  /**
   * @param {string} sn
   * @return {Promise<InstalledTariffOption>}
   */
  async prepaidStarterPackDetail({ sn }) {
    return this._tariffOptionRequest({
      sn,
      tariffOptionId: TARIFF_OPTION_ID_PREPAID_STARTER_PACK_DETAIL,
    });
  }
}
